import { Config } from './Config';

export const RAIL_NEW_BUBBLE_WEBSITES = ['ES', 'IT', 'FR', 'OPES', 'OPIT', 'OPFR', 'GOFR'];

export const isRailNewBubbleMarket = () => RAIL_NEW_BUBBLE_WEBSITES.includes(Config.get('website'));

export const isBrandCountry = (brand, countryId) => {
    const currentBrand = Config.get('brand');
    const currentCountryId = Config.get('countryId');

    if (typeof countryId !== 'string' || countryId.trim() === '') {
        return false;
    }

    if (typeof currentCountryId !== 'string' || currentCountryId.trim() === '') {
        return false;
    }

    return currentBrand === brand && currentCountryId.toLowerCase() === countryId.toLowerCase();
};

export const isOpodoAE = () => isBrandCountry('OP', 'ae');
